module.exports = __webpack_public_path__ + "static/media/Benefits.79d674ff.jpeg";